import AjaxLoad from '../../lib/ajax-load';
import { getOffset, smoothScrollTo } from '../../js/helper';

class ProductOverview {
    constructor (element, options) {
        this.$productOverview = element;
        this.$form = element.querySelector('[data-product-overview="form"]');
        this.$button = element.querySelectorAll('[data-product-overview="button"]');
        this.$buttonClose = element.querySelector('[data-product-overview="close"]');
        this.$buttonFilter = element.querySelector('[data-product-overview="filter"]');
        this.$bar = element.querySelector('[data-product-overview="bar"]');
        this.$overviewSidebar = element.querySelector('[data-product-overview="wrapper"]');
        this.$overview = element.querySelector('[data-overview="root"]');
        this.$target = element.querySelector('[data-product-overview="target"]');
        this.formURL = this.$form.getAttribute('action');
        this.customEvent = new CustomEvent('ajaxload');
        this.$sidebar = element.querySelector('[data-product-overview="sidebar"]');

        this.$pagination = this.$productOverview.querySelector('[data-product-overview="pagination"]');
        // this.prevNext = [].slice.call(this.$pagination.querySelectorAll('[data-product-overview="paginationurl"]'));
        // this.$select = this.$pagination.querySelector('[data-product-overview="paginationselect"]');

        const settings = {
            onSubmitted: null
        };

        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        this.getUrlParameters();
        this.setEvents();
    }

    getUrlParameters () {
        const currentUrl = window.location.href;
        const parsedUrl = new URL(currentUrl);
        const params = new URLSearchParams(parsedUrl.search);

        const paramObj = {};

        params.forEach((value, key) => {
            paramObj[key] = value;
            this.setFilterInitially(paramObj);
        });
    }

    setFilterInitially (paramObj) {
        const $$inputs = this.$productOverview.querySelectorAll('input, select, textarea');

        $$inputs.forEach(input => {
            const name = input.name;

            if (Object.prototype.hasOwnProperty.call(paramObj, name)) {
                const value = paramObj[name];

                if (input.type === 'checkbox' || input.type === 'radio') {
                    if (input.value === value) {
                        input.checked = true;
                    }
                } else {
                    input.value = value;
                }
            }
        });
    }

    setEvents () {
        this.$target.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-product-overview') === 'paginationurl') {
                e.preventDefault();
                this.loadContent(this.formURL, 'GET', e.target.href.split('?')[1]);
            }
        });

        this.$target.addEventListener('change', (e) => {
            e.preventDefault();
            if (e.target.getAttribute('data-product-overview') === 'paginationselect') {
                if (e.target.value !== '') {
                    this.loadContent(this.formURL, 'GET', e.target.value.split('?')[1]);
                }
            }
        });

        // History Event Listener
        window.addEventListener('popstate', (e) => {
            if (e.state !== null) {
                if (e.state.type === 'ajax' || e.state.type === 'initial') {
                    location.replace(window.location.href);
                }
            } else {
                location.replace(window.location.href);
            }
        });

        this.bindResetEvent(this.$productOverview);

        // load filter desktop or mobile on init
        if (window.innerWidth <= 768) {
            this.showMobileFilter();
            this.showFilterLength();
        } else {
            this.showDesktopFilter();
        }
    }

    // desktop filter
    showDesktopFilter () {
        this.$form.addEventListener('change', (e) => {
            e.preventDefault();
            const targetAttribute = e.target.getAttribute('data-product-overview');

            if (targetAttribute !== 'paginationselect' && targetAttribute !== 'accordion') {
                this.disableFilter();
                this.loadContent(this.formURL, 'POST');
            }
        });
    }

    // mobile filter
    showMobileFilter () {
        this.$form.addEventListener('change', (e) => {
            this.showFilterLength();

            e.preventDefault();
            const targetType = e.target.type;

            if (targetType !== 'checkbox') {
                this.loadContent(this.formURL, 'POST');
            }
        });

        this.$buttonClose.addEventListener('click', () => {
            this.$overviewSidebar.classList.remove('sticky');
        });

        this.$buttonFilter.addEventListener('click', () => {
            if (this.$overviewSidebar.classList.contains('sticky')) {
                this.$overviewSidebar.classList.remove('sticky');
            } else {
                this.$overviewSidebar.classList.add('sticky');
            }
        });

        for (let i = 0; i < this.$button.length; i++) {
            this.$button[i].addEventListener('click', () => {
                this.loadContent(this.formURL, 'POST');
                this.showFilterLength();
                this.closeAllFilter();
            });
        }

        window.addEventListener('scroll', () => {
            const rect = this.$bar.getBoundingClientRect();
            const elemTop = rect.top;

            if (elemTop <= 0) {
                this.$bar.classList.add('sticky');
            }

            if (elemTop > 0) {
                this.$bar.classList.remove('sticky');
                this.$overviewSidebar.classList.remove('sticky');
            }
        });
    }

    closeAllFilter () {
        this.$button.forEach((button) => {
            const $accordeonLabel = button.closest('.product-overview__filter').querySelector('label');

            if ($accordeonLabel) {
                if ($accordeonLabel.classList.contains('is--active')) {
                    $accordeonLabel.click();
                }
            }
        });
    }

    // show active filter length
    showFilterLength () {
        const $processInputs = this.$sidebar.querySelectorAll('input[type="checkbox"][id^=process]:checked').length;
        const $rangeInputs = this.$sidebar.querySelectorAll('input[type="checkbox"][id^=productrange]:checked').length;
        const $range = this.$sidebar.querySelectorAll('[data-product-filter="length"]')[0];
        const $process = this.$sidebar.querySelectorAll('[data-product-filter="length"]')[1];

        if ($rangeInputs > 0) {
            $range.classList.add('is--active');
            $range.innerHTML = $rangeInputs;
        } else {
            $range.classList.remove('is--active');
        }

        if ($processInputs > 0) {
            $process.classList.add('is--active');
            $process.innerHTML = $processInputs;
        } else {
            $process.classList.remove('is--active');
        }
    }

    // removes active filter
    resetFilterInitiallyLength () {
        const $process = this.$sidebar.querySelectorAll('[data-product-filter="length"]')[0];
        const $range = this.$sidebar.querySelectorAll('[data-product-filter="length"]')[1];

        $process.classList.remove('is--active');
        $range?.classList.remove('is--active');
    }

    // disables active filter in desktop
    disableFilter () {
        this.$form.classList.add('is--disabled');

        const $inputs = [].slice.call(this.$sidebar.querySelectorAll('input[type="checkbox"]:not([value=""]):not([data-product-overview="accordion"]):not([disabled]):not(:checked)'));
        $inputs.forEach((input) => {
            input.disabled = true;
        });
    }

    // enables active filter in desktop
    enableFilter () {
        this.$form.classList.remove('is--disabled');

        const $inputs = [].slice.call(this.$sidebar.querySelectorAll('input[type="checkbox"][disabled]:not([value=""]):not([data-product-overview="accordion"])'));
        $inputs.forEach((input) => {
            input.disabled = false;
        });
    }

    bindResetEvent ($content) {
        const $filterResets = $content.querySelectorAll('[data-filter-reset]');

        for (let i = 0; i < $filterResets.length; i++) {
            const $filterReset = $filterResets[i];

            $filterReset.addEventListener('click', () => {
                this.resetFilterInitiallyForm();
                this.resetFilterInitiallyLength();
            });
        }
    }

    loadContent (url, method, page) {
        this.$overview.classList.add('is--loading');
        smoothScrollTo(0, getOffset(this.$overview).top - 150, 500);

        const formData = new FormData(this.$form);

        if (typeof page !== 'undefined') {
            let nextPage;

            if (page.indexOf('&') !== -1) {
                const parameters = page.split('&');

                parameters.forEach((value) => {
                    if (value.indexOf('page') !== -1) {
                        nextPage = value.split('=')[1];
                    }
                });
            } else {
                nextPage = page.split('=')[1];
            }

            if (method.toUpperCase() === 'GET') {
                formData.append('page', nextPage);
                method = 'POST';
            }
        }

        const ajaxLoad = new AjaxLoad(url, {
            requestMethod: method,
            requestData: formData,
            onSuccess: (resultText) => {
                this.setContent(this.createElementFromHTML(resultText), method, () => {
                    if (typeof this.settings.onSubmitted === 'function') {
                        this.settings.onSubmitted(this.$target);
                        this.bindResetEvent(this.$target);
                    }
                    this.enableFilter();

                    history.pushState({ type: 'ajax' }, null, window.location.href);
                    history.replaceState({ type: 'ajax' }, null, window.location.href.split('?')[0] + '?' + this.serializeForm(this.$form));
                });
            }
        });

        ajaxLoad.initialize();
    }

    createElementFromHTML (htmlString) {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        if (div.children.length > 1) {
            const itemsArray = [];
            Array.prototype.push.apply(itemsArray, div.children);
            return itemsArray;
        } else {
            return div.firstChild;
        }
    }

    setContent (resultText, method, callback) {
        this.$target.innerHTML = resultText.innerHTML;

        setTimeout(() => {
            this.$overview.classList.remove('is--loading');
            window.dispatchEvent(this.customEvent);

            if (typeof callback === 'function') {
                callback();
            }
        }, 1100);
    }

    resetFilterInitiallyForm () {
        if (!this.$sidebar) {
            return false;
        }

        const $$checkboxes = this.$sidebar.querySelectorAll('input[type="checkbox"]:not([data-product-overview="accordion"])');
        // control variable to check if there were any checked checkboxes to prevent ajax load when no boxes are checked
        let hasCheckedCheckbox = false;

        for (let i = 0; i < $$checkboxes.length; i++) {
            const $checkbox = $$checkboxes[i];

            if ($checkbox.checked) {
                hasCheckedCheckbox = true;
                $checkbox.checked = false;
            }
        }

        if (hasCheckedCheckbox) {
            this.loadContent(this.formURL, 'POST');
        }
    }

    serializeForm (form) {
        let field;
        const s = [];

        if (typeof form === 'object' && form.nodeName === 'FORM') {
            for (let i = 0; i < form.elements.length; i++) {
                field = form.elements[i];

                if (field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit' && field.type !== 'button') {
                    if (field.type === 'select') {
                        for (let j = form.elements[i].options.length - 1; j >= 0; j--) {
                            if (field.options[j].selected) {
                                s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[j].value);
                            }
                        }
                    } else {
                        if ((field.type === 'checkbox') && field.checked) {
                            s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value);
                        } else {
                            if (field.type === 'radio' && field.checked) {
                                s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value);
                            } else {
                                if (field.type !== 'radio' && field.type !== 'checkbox') {
                                    s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value);
                                }
                            }
                        }
                    }
                }
            }
        }
        return s.join('&').replace(/%20/g, '+');
    }
}

export { ProductOverview };
